/**
 * 商城缓存购物车bar
 */
import React, { FC, useMemo } from 'react'
import { Icon } from '@cps'
import { decorationMobx } from '@mobxStore'
import { shopcartMobx } from 'mobx/mall'
import { observer } from 'mobx-react'
import { MallController, TCheckoutType } from '@ctrls/mallController'
import './index.scss'
import { showMsg } from '@utils'

// interface
interface IProps {
  hasTxt?: boolean;
}

const ShopCartBar: FC<IProps> = ({ hasTxt = false }) => {
  const { mallGlobalDecorates: { collect } } = decorationMobx
  const { cartTotalCnt } = shopcartMobx
  // 当前用户语言是否是商户语言
  const isLikeLang = Config.i18n.toLowerCase().indexOf(bo) > -1
  const isEmpty = cartTotalCnt <= 0

  const handToCheckout = () => {
    if (isEmpty) {
      showMsg(i18n.t('mall.emptyShopCartError'))
      return
    }
    MallController.goCheckout(TCheckoutType.Cart)
  }

  return (
    <div className='shopcart-bar-container' data-cypid='shopcart-bar-container' onClick={handToCheckout}>
      <div className='shopcart-wrap'>
        {
          collect.img?.type === 'product' ? <div className='icon' style={{ backgroundImage: `url(${collect.img?.value})` }}></div> : <Icon icon='dicon' name={collect.img?.value || 'mall-shopcart2'} />
        }
        {!isEmpty && <div className='badge'>{cartTotalCnt}</div>}
      </div>
      {hasTxt && <span className='txt'>{(isLikeLang && collect?.home) || i18n.t('common.cart')}</span>}
    </div>
  )
}
export default observer(ShopCartBar)
